export class ConveyanceCurrentAssessmentRulesRawDto {
    communityId: number;

    regularAssessmentRuleCodeId: number;
    specialAssessmentRuleCodeId: number;

    billingRuleCodeIds: number[];
    overrideRequiredBillingRules = false;
}
